// 本模块用来调用招聘接口与相关逻辑处理
import axios from "axios";
export default {
  recruits(data) {
    return axios({
      url: "/api/recruit",
      method: "get",
      params: {
        per_page: data.per_page,
        page: data.page,
        job_name: data.job_name,
        salary_requirement: data.salary_requirement,
        experience: data.experience,
        education: data.education,
        province_id: data.province_id,
        city_id: data.city_id
      }
    });
  }
};



// WEBPACK FOOTER //
// ./src/api/recruit.js